import { CultureSourceChip } from "./CultureSourceReadinessBadge";

const ALERT_LABELS = {
  stale_success: "Stale",
  never_succeeded: "Never succeeded",
  schedule_disabled: "Not scheduled",
  env_var_missing: "Env var missing",
  run_failing: "Run failing",
  parser_drift: "Parser drift",
  zero_records_repeated: "Zero records",
  virtual_child_stale: "Child stale",
  venue_pipeline_unmapped: "No map venues",
};

const ALERT_TITLES = {
  stale_success: "The last successful ingest is older than the freshness threshold.",
  never_succeeded: "This source has never completed a successful ingest.",
  schedule_disabled: "No enabled schedule is covering this source.",
  env_var_missing: "A required environment variable is missing, so ingest cannot run.",
  run_failing: "Recent runs are failing. Open Details or View runs for the error.",
  parser_drift: "The parser output no longer matches the expected feed shape.",
  zero_records_repeated: "Recent runs completed but found no records.",
  virtual_child_stale: "One or more child feeds in this virtual source are stale.",
  venue_pipeline_unmapped: "Venue records exist but are not mapped onto the culture map.",
};

function resolveKind(alert) {
  if (alert.severity === "error") return "blocked";
  if (alert.type === "parser_drift" || alert.type === "zero_records_repeated" || alert.type === "run_failing") {
    return "blocked";
  }
  if (alert.type === "stale_success" || alert.type === "never_succeeded") return "warning";
  return "warning";
}

const CultureHealthAlertBadge = ({ alert }) => {
  if (!alert?.type) return null;

  const kind = resolveKind(alert);
  const label = ALERT_LABELS[alert.type] || alert.type;
  const title = alert.message || ALERT_TITLES[alert.type] || `Health alert: ${alert.type}.`;

  return (
    <CultureSourceChip
      label={label}
      kind={kind}
      title={title}
      className={`culture-readiness-badge culture-readiness-badge--${kind} culture-health-alert-badge culture-health-alert-badge--${alert.type}`}
    />
  );
};

export function renderCultureHealthAlerts(alerts = [], limit = 8) {
  return (alerts || []).slice(0, limit).map((alert) => (
    <CultureHealthAlertBadge key={`${alert.type}-${alert.message}`} alert={alert} />
  ));
}

export default CultureHealthAlertBadge;
